import styled from 'styled-components';
import { baseDark } from 'crehana-ui/styles/colors';

// styles.Wrapper
export const Nav = styled.nav`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1200;
  opacity: 1;
  pointer-events: all;
  transform: translateY(0);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;

  &.absolute {
    position: absolute !important;
  }

  &.hide {
    transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out,
      z-index 0.3s ease 0.5s;
    opacity: 0;
    pointer-events: none;
    z-index: -1;
    transform: translateY(-100%);
  }
  &.mainmenu-wrapped {
    background-color: #fff;
  }

  &.mainmenu-with-border {
  }
`;

export const Inner = styled.div<{ crehanaUI?: boolean; customStyles?: string }>`
  height: 52px;
  background-color: #fff;
  padding: 0 20px;
  margin: 0 auto;
  z-index: 1200;
  transition: background-color 0.3s ease-in-out;

  &.transparent {
    background-color: transparent;
  }

  &.dark {
    background-color: ${baseDark};
  }

  overflow: visible;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    padding: 0 40px;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 0 32px;
    height: 72px;
  }

  @media (min-width: 1140px) {
    padding: 0 10%;
  }

  ${props =>
    props.crehanaUI &&
    `
    padding: 0 16px;
    max-width: 1152px;
    ${props.theme.breakpoints.up('md')} {
      padding: 0 20px;
    }
  `}
  ${props => props.customStyles || ''}
`;
